import { render, staticRenderFns } from "./CardCollapse.vue?vue&type=template&id=6be7bd95&scoped=true&"
import script from "./CardCollapse.vue?vue&type=script&lang=js&"
export * from "./CardCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7bd95",
  null
  
)

export default component.exports